import { useCallback } from 'react';

import CircleOutlined from '@/assets/icons/CircleOutlined';
import DoubleSquareIcon from '@/assets/icons/DoubleSquareIcon';
import MenuOutlinedIcon from '@/assets/icons/MenuOutlinedIcon';
import RoundedSquareOutlined from '@/assets/icons/RoundedSquareOutlined';
import useColor from '@/hooks/domain/useColor';

const useTopicLevelIcon = () => {
  const color = useColor();
  const getIcons = useCallback(
    (level: number, size: number = 16, _color: string = color.primary100) => {
      const iconColor = _color;
      switch (level) {
        case 2:
          return (
            <DoubleSquareIcon color={iconColor} style={{ fontSize: size }} />
          );
        case 3:
          return (
            <RoundedSquareOutlined
              color={iconColor}
              style={{ fontSize: size }}
            />
          );
        case 4:
          return (
            <CircleOutlined color={iconColor} style={{ fontSize: size }} />
          );
        default:
          return (
            <MenuOutlinedIcon color={iconColor} style={{ fontSize: size }} />
          );
      }
    },
    [color.primary100],
  );
  return getIcons;
};

export default useTopicLevelIcon;
